import React from "react";
import Head from "next/head";

export default function OrganizationNotFound() {
  return (
    <div className="h-screen min-h-full bg-inherit px-4 py-16 sm:px-6 sm:py-24 md:grid md:place-items-center lg:px-8">
      <Head>
        <title>Not Found</title>
      </Head>
      <div className="mx-auto max-w-max">
        <main className="sm:flex">
          <p className="text-4xl font-extrabold text-indigo-600 dark:text-slate-100 sm:text-5xl">404</p>
          <div className="sm:ml-6">
            <div className="sm:border-l sm:border-gray-200 sm:pl-6">
              <h1 className="text-4xl font-extrabold tracking-tight text-gray-900 dark:text-slate-100 sm:text-5xl">
                Organization Not Found
              </h1>
              <p className="mt-1 text-base text-gray-500 dark:text-slate-400">
                The organization you are looking for does not exist.
              </p>
            </div>
            <div className="mt-10 flex space-x-3 sm:border-l sm:border-transparent sm:pl-6">
              <a
                href="mailto:support@fundview.com"
                className="inline-flex items-center rounded-md border border-transparent bg-indigo-100 px-4 py-2 text-sm font-medium text-indigo-700 hover:bg-indigo-200 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
              >
                Contact support
              </a>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
